"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cache = void 0;
class Cache {
    constructor() {
        this.valves = new Map();
    }
    hasValveCache(key) {
        return this.valves.has(key);
    }
    addValveCache(valve) {
        if (!this.valves.has(valve.manufacturerSku)) {
            this.valves.set(valve.manufacturerSku, valve);
        }
    }
    readValveCache(key) {
        return this.valves.get(key);
    }
    readValveCacheAll() {
        return this.valves;
    }
    emptyValveCache() {
        this.valves.clear();
    }
}
exports.Cache = Cache;
